import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { onAuthStateChanged, getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../Firebase/firebaseconfig";
import { crearUsuarioSiNoExiste, obtenerUsuario } from "../../Firebase/userService";
import { buildRolePermissions, can as canPermission } from "../../helpers/permisos";

const UserContext = createContext();
export const useUserContext = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [roleData, setRoleData] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [permissionsLoading, setPermissionsLoading] = useState(true);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (fbUser) => {
      setPermissionsLoading(true);

      if (fbUser) {
        await crearUsuarioSiNoExiste(fbUser);

        const data = await obtenerUsuario(fbUser.uid);
        const userData = { uid: fbUser.uid, ...data };
        const rol = userData.rol || "vendedor";

        let roleDoc = null;

        try {
          const roleSnap = await getDoc(doc(db, "roles", rol));
          roleDoc = roleSnap.exists()
            ? { id: roleSnap.id, ...roleSnap.data() }
            : null;
        } catch (err) {
          console.error("Error cargando permisos del rol:", err);
        }

        setUser(userData);
        setRoleData(roleDoc);
        setPermissions(buildRolePermissions(rol, roleDoc));
      } else {
        setUser(null);
        setRoleData(null);
        setPermissions({});
      }

      setPermissionsLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  const can = useCallback(
    (permission) => canPermission(permissions, permission),
    [permissions]
  );

  const contextValue = useMemo(
    () => ({
      user,
      setUser,
      role: user?.rol || "",
      roleData,
      permissions,
      permissionsLoading,
      can,
    }),
    [user, roleData, permissions, permissionsLoading, can]
  );

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};
